/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Effort_Cooldown_RideInputs */

const en_ui_effort_cooldown_ride = /** @type {(inputs: Ui_Effort_Cooldown_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cool-down`)
};

const de_ui_effort_cooldown_ride = /** @type {(inputs: Ui_Effort_Cooldown_RideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausfahren`)
};

/**
* | output |
* | --- |
* | "Cool-down" |
*
* @param {Ui_Effort_Cooldown_RideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_effort_cooldown_ride = /** @type {((inputs?: Ui_Effort_Cooldown_RideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Effort_Cooldown_RideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_effort_cooldown_ride(inputs)
	return de_ui_effort_cooldown_ride(inputs)
});